class LinkUtils {
  static validateLink(link: string) {
    if (link) {
      return link?.match(/^http[s]?:\/\//) ? link : `http://${link}`;
    } else {
      return link;
    }
  }

  static getFirstLinkFromText(text: string) {
    try {
      const linkRegex = /(?:www\.|(?!www))[^\s.]+\.[^\s]{2,}|www\.[^\s]+\.[^\s]{2,}/gi;
      const linksFound = text.match(linkRegex);
      const link = linksFound?.length ? linksFound[0] : null;
      const linkConverted = link ? new URL(this.validateLink(link)) : null;

      return linkConverted;
    } catch (error) {
      return null;
    }
  }

  static isValidHttpURL(url: string) {
    try {
      const urlInstance = new URL(url);

      return urlInstance.protocol === 'http:' || urlInstance.protocol === 'https:';
    } catch (_) {
      return false;
    }
  }

  static extractURLfromText(text: string) {
    try {
      const linkRegex =
        /((?:https?:\/\/|[a-zA-Z0-9]{1,}\.{1}|\b)(?:\w{1,}\.{1}){1,5}(?:com|org|edu|gov|uk|net|ca|de|jp|fr|au|us|ru|ch|it|nl|se|no|es|mil|iq|io|ac|ly|sm|es|br|nz|au|be){1}(?:\/[a-zA-Z0-9]{1,})*\.?[a-zA-Z-_+=#?.?/?0-9/>]*)/gm;
      const matches = text.match(linkRegex);
      return matches?.[0] ?? null;
    } catch (error) {
      return null;
    }
  }
}

export default LinkUtils;
